import React, { useState } from 'react';
import { RefreshCw, LogOut } from 'lucide-react';
import { BRAND } from '../../lib/brand';
import { useAuth } from '../../hooks/useAuth';

// Signed in, but the profile will not load after retrying. Without this the
// router fell through to the login page, which reads as being logged out at
// random: the client types their password again and it works, so nothing ever
// gets reported. Say what happened and offer the two useful actions.
export default function ProfileLoadError() {
  const { refreshProfile, signOut } = useAuth();
  const [retrying, setRetrying] = useState(false);

  async function retry() {
    setRetrying(true);
    try {
      await refreshProfile();
    } finally {
      setRetrying(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--off-white)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: '1.5rem',
    }}>
      <div className="card" style={{
        background: 'var(--white)', borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-md)',
        padding: '2rem 1.75rem', maxWidth: 420, width: '100%', textAlign: 'center',
      }}>
        <img
          src={BRAND.logo}
          alt=""
          style={{ width: 54, height: 54, borderRadius: '50%', objectFit: 'cover', margin: '0 auto 1rem', display: 'block' }}
        />
        <h1 style={{
          fontFamily: 'var(--font-serif)', fontSize: '1.35rem', color: 'var(--navy)',
          margin: '0 0 0.6rem', fontWeight: 600,
        }}>
          We couldn't load your details
        </h1>
        <p style={{ fontSize: '0.95rem', lineHeight: 1.65, color: 'var(--charcoal)', margin: '0 0 1.5rem' }}>
          You're still signed in. This is usually a dropped connection, so try again in a
          moment. If it keeps happening, message {BRAND.therapistName}.
        </p>
        <button
          onClick={retry}
          disabled={retrying}
          style={{
            width: '100%', padding: '0.8rem', border: 'none', borderRadius: 'var(--radius-md)',
            background: 'var(--navy)', color: 'var(--cream)', fontSize: '0.95rem', fontWeight: 600,
            fontFamily: 'var(--font-sans)', cursor: retrying ? 'default' : 'pointer',
            opacity: retrying ? 0.7 : 1,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
          }}
        >
          <RefreshCw size={16} />
          {retrying ? 'Trying again…' : 'Try again'}
        </button>
        <button
          onClick={signOut}
          style={{
            width: '100%', marginTop: '0.75rem', padding: '0.7rem', background: 'none',
            border: 'none', color: 'var(--navy)', fontSize: '0.9rem', fontFamily: 'var(--font-sans)',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem',
          }}
        >
          <LogOut size={15} /> Sign out
        </button>
      </div>
    </div>
  );
}
